export default __webpack_public_path__ + "assets/png/e661510cdb8e04f5fe5a3398e02cb192.png";